export default "__VITE_ASSET__596dd837__"